import { Directive, ElementRef, Renderer2, Inject, OnInit, Input, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
    selector: '[popover]',
})
export class PopoverDirective implements OnInit {

    /**
     * Mensagem que irá aparecer dentro do popover
     */
    @Input() popover: string = '';
    /**
     * Tipo de evento que dispara o comportamento do popover
     */
    @Input() typeEvent: string = 'mouseenter';
    /**
    * Mensagem que irá aparecer dentro do popover
    * center | right | left
    */
    @Input() position: string = 'center';
    /**
     * Eventos acionadores popover mouseenter
     */
    @HostListener('mouseenter') onmouseenter() {
        if (this.typeEvent == 'mouseenter')
            this.showPopover();
    }
    /**
     * Eventos acionadores popover click
     */
    @HostListener('click') onclick() {
        if (this.typeEvent == 'click')
            this.showPopover();
    }
    /**
     * Eventos acionadores popover mouseleave
     */
    @HostListener('mouseleave') onmouseleave() {
        this.hidePopover();
    }

    constructor(private elementRef: ElementRef, private renderer: Renderer2, @Inject(DOCUMENT) private document) {
    }

    ngOnInit() {
        //chama função criação do popover
        this.createPopover()
    }

    /**
     * Mostra o popover
     */
    showPopover() {
        this.renderer.addClass(this.elementRef.nativeElement, 'custom-popover-active');
    }
    /**
     * Oculta o popover
     */
    hidePopover() {
        this.renderer.removeClass(this.elementRef.nativeElement, 'custom-popover-active');
    }
    /**
     * Cria o popover
     */
    createPopover() {
        //remove o titulo para não interferir com o popover da diretiva
        this.renderer.removeAttribute(this.elementRef.nativeElement, 'title');
        //Cria o elemento
        const popover = document.createElement('div');
        popover.className = 'custom-popover';
        //insere o conteudo
        let content = document.createTextNode(this.popover);
        popover.appendChild(content);
        //renderiza o popover
        this.renderer.appendChild(this.elementRef.nativeElement, popover);
        // seta a posição
        this.setPosition(this.position, popover);
    }
    /**
     * Seta a posição no popover
     * @param position string center | right | left
     * @param element HTMLElement é o elemento que está sendo estilizado
     */
    setPosition(position: string, element: HTMLElement) {
        if (position == 'center' || position == 'right' || position == 'left') {
            position += 'Popover';
            this[position](element);
        }
    }
    /**
     * Centraliza o popover o popover
     * @param element HTMLElement é o elemento que está sendo estilizado
     */
    centerPopover(element: HTMLElement) {
        let marginLeft = `-${element.offsetWidth / 2}px`;
        this.renderer.setStyle(element, 'marginLeft', marginLeft);
        this.renderer.setStyle(element, 'left', '50%');
    }
    /**
     * Centraliza a direita o popover o popover
     * @param element HTMLElement é o elemento que está sendo estilizado
     */
    rightPopover(element: HTMLElement) {
        this.renderer.setStyle(element, 'right', '0');
    }
    /**
     * Centraliza a direita o popover o popover
     * @param element HTMLElement é o elemento que está sendo estilizado
     */
    leftPopover(element: HTMLElement) {
        this.renderer.setStyle(element, 'left', '0');
    }

}




// WEBPACK FOOTER //
// ./src/app/directives/popover/popover.directive.ts